/** @format */

import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import ThemeProvider from './theme';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MessageOverlay from './components/MessageOverlay/MessageOverlay';
import { AxiosInterceptorProvider, NetworkStatusProvider } from './provider';
import './theme/globalStyles.css';


const basename = window.location.pathname.startsWith('/pune-jlr') ? '/pune-jlr' : '/';

const root = ReactDOM.createRoot(
	document.getElementById('root')
);
root.render(
	<Provider store={store}>
		<ThemeProvider>
			<MessageOverlay>
				<BrowserRouter
					basename={basename}
					future={{
						v7_startTransition: true,
						v7_relativeSplatPath: true,
					}}
				>
					<AxiosInterceptorProvider>
						<ToastContainer
							position="top-right"
							autoClose={3000}
							hideProgressBar={false}
							newestOnTop={false}
							closeOnClick
							rtl={false}
							pauseOnFocusLoss
							draggable
							pauseOnHover
						/>
						<NetworkStatusProvider>
							<App />
						</NetworkStatusProvider>
					</AxiosInterceptorProvider>
				</BrowserRouter>
			</MessageOverlay>
		</ThemeProvider>
	</Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
